import { LocalStorageKeysEnum } from './enum';

export const storageToken = () => {
  return localStorage.getItem(LocalStorageKeysEnum.TOKEN);
};

export const storageId = () => {
  return localStorage.getItem(LocalStorageKeysEnum.ID);
};

export const storagePublishUrl = () => {
  return localStorage.getItem(LocalStorageKeysEnum.PUBLISH_URL);
};

export const storageIdSurvey = () => {
  return localStorage.getItem(LocalStorageKeysEnum.ID_SERVEY);
};

export const storageTelegramBotLink = () => {
  return localStorage.getItem(LocalStorageKeysEnum.TELEGRAM_BOT_LINK);
};
